import { DeliveryMode } from '@spartacus/cart/base/root';

export enum CheckoutConstants {
  DELIVERY_FEE = 'delivery-fee',
  DELIVERY_FEE_CUSTOM_MSG = 'delivery-fee-custom-msg',
  GST_MSG = 'gst-msg',
  DELIVERY_FEE_IN_ORDER_HISTORY = 'delivery-fee-in-order-history',
  GST_EXCLUSIVE = 'gst-exclusive',
  GST_INCLUSIVE = 'gst-inclusive',
  PLANNED_ORDER = 'planned-order',
  DOWNLOAD_INVOICE = 'download-invoice',
  DOWNLOAD_TRACK_AND_TRACE = 'download-track-and-trace',
  DYNAMIC_DATE_FORMAT = 'dynamic-date-format',
  TRACKING_ID = 'tracking-id',
  SPLIT_DELIVERY = 'split-delivery',
  ORDER_TYPE = 'order-type',
  FREE_DELIVERY = 'free-delivery',
  EXPECTED_SHIPMENT_DATE = 'expected-shipment-date',
  SAME_DAY_DELIVERY = 'same-day-delivery',
}

export interface CheckoutFormsErrorModel {
  CHECKOUT_ORDER_TYPE?: boolean;
  CHECKOUT_ORDER_REVIEW?: boolean;
}

export interface PostPlacedOrderPayload {
  fields?: string;
  cartId?: string;
  securityCode?: string;
  requestDeliveryDate?: string;
  additionalEmail?: string;
  orderType?: string;
  deliverFullOrder?: boolean;
  currentId?: string;
  termsChecked?: boolean;
  purchaseNumber?: string;
  deliveryMode?: DeliveryMode;
  requestCancelOrderDate?: string;
  paymentMode?: PaymentMode;
}

export interface OrderTypePayload {
  orderType?: string;
}

export interface PostBillingAddressPayload {
  addressId: string;
  cartId: string;
}

export interface PaymentMode {
  code: string;
  name: string;
  paymentTerms?: string;
  checkoutPaymentType?: string;
}
